<template>
    <div class="pa-0">
        Not Found
    </div>
</template>

<script>
export default {};
</script>

<style></style>
